import React, { useState, useEffect } from "react";
import "../styles/global.css"; // Import global styles
import PriceDisplay from "../elements/ProductPrice";
import { currentProductPrice } from "../functions/currentProductPrice";
import ListItem_Ribbon from "./ListItem_Ribbon";
import cdn from "../utils/cdn";

const ListItem_Preview = ({ product, priceTheme, ribbonSettings }) => {
  const [priceInfo, setPriceInfo] = useState({});

  useEffect(() => {
    const fetchPriceInfo = async () => {
      const result = await currentProductPrice(product);
      setPriceInfo(result); //
    };

    fetchPriceInfo();
  }, [product]);

  const productPrice = product?.price || product?.priceInfo?.finalPrice || product?.pricing?.finalPrice || product?.listing_price;

  return (
    <a href={`/Listing/${product?.seller_product_id}`} style={{ ...styles.listItemContainer, textDecoration: "none" }}>
      {/* Image Section */}
      <div style={styles.listItemImageContainer}>
        <ListItem_Ribbon product={product} priceInfo={priceInfo} ribbonSettings={ribbonSettings} />
        {productPrice && <PriceDisplay price={parseFloat(priceInfo?.finalPrice).toFixed(2)} priceInfo={priceInfo} priceTheme={"preview_banner"} />}
        <img
          src={product?.images?.length > 0 ? cdn.image(product.images[0], { w: 500 }) : "/images/no_product_image.png"}
          alt={product?.name || "Product"}
          style={styles.listItemImage}
          onLoad={(e) => (e.target.style.opacity = 1)}
          onError={(e) => (e.target.src = "/images/no_product_image.png")}
        />
      </div>

      {/* Product Details */}
      <div style={styles.listItemContent}>
        <div style={styles.productPrice}>{productPrice ? <PriceDisplay priceInfo={priceInfo} priceTheme={priceTheme} /> : "Price Not Available"}</div>
        <div style={styles.productBrand}>{product?.brand_name}</div>
        <div style={styles.productName}>{product?.product_name}</div>
      </div>
    </a>
  );
};

const styles = {
  listItemContainer: {
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    margin: "5px 0",
    cursor: "pointer",
  },
  listItemImageContainer: {
    display: "flex",
    position: "relative",
    width: "100%",
    background: "#f5f5f5",
    borderRadius: "8px",
    aspectRatio: "1 / 1",
    overflow: "hidden",
    minHeight: "120px",
  },
  listItemImage: {
    display: "flex",
    objectFit: "cover",
    width: "100%",
    height: "100%",
  },
  listItemContent: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0",
  },
  productPrice: {
    color: "black",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  productBrand: {
    fontSize: "1rem",
    fontWeight: "800",
    marginTop: "5px",
    color: "black",
    marginBottom: "2px",
  },
  productName: {
    fontSize: "1rem",
    fontWeight: "300",
    color: "black",
    marginTop: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
  },
};

export default ListItem_Preview;
